import BaseModal from "../BaseModal/BaseModal";

export default function ViewImageModal({className, src, ...props}) {

    return (
        <BaseModal innerClassName={"lg:w-auto "} className={` ${className}`} {...props}>
            <div className={"w-auto flex justify-center  py-2 my-2 items-center max-h-full rounded"}>
                <div className={""}>
                    <img
                        className={"w-auto h-full object-contain"}
                        src={src}
                        alt={"image"}
                    />
                </div>
            </div>
        </BaseModal>

    )
}